import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurLegacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-legacy" className="dark bg-background text-foreground relative min-h-screen flex flex-col justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-background/90 z-10" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--border)_1px,_transparent_1px)] [background-size:40px_40px] opacity-[0.03] z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/dynestate_skyline_smoke_overlay.png" alt="Abstract skyline with smoke overlay" className="w-full h-full object-cover opacity-30 grayscale mix-blend-overlay" />
      </div>

      <div className="container relative z-20 mx-auto px-6 md:px-12 flex flex-col justify-center h-full">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {}
          <div className="mb-12 flex items-center gap-6">
            <div className="h-[1px] w-16 bg-border/60"></div>
            <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground font-mono">
              Our Philosophy
            </span>
          </div>

          {}
          <div className="relative w-full mb-16 md:mb-24">
            <h1 className="font-serif text-7xl md:text-9xl lg:text-[11rem] xl:text-[13rem] leading-[0.85] tracking-tighter text-foreground whitespace-nowrap lg:absolute lg:left-0 lg:w-[150%]">
              Institutional <span className="text-muted-foreground/40">Grade.</span>
            </h1>
            {}
            <div className="hidden lg:block h-[11rem] xl:h-[13rem] w-full pointer-events-none" aria-hidden="true"></div>
          </div>

          {}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 border-t border-border/40 pt-12 md:pt-16">
            <div className="lg:col-span-4">
              <h2 className="text-2xl md:text-3xl font-light leading-tight text-foreground/90">
                Bridging the gap between direct lending and private credit.
              </h2>
            </div>
            
            <div className="lg:col-span-8 flex flex-col gap-10">
              <div className="grid md:grid-cols-2 gap-10 text-muted-foreground">
                <p className="text-lg leading-relaxed font-light">DynEstate® operates at the intersection of Real Estate Capital, Business Funding, and Private Credit, operating as a direct capital partner to businesses, investors, and sponsors. We structure and deliver financing solutions that combine the speed of private capital with the rigor, discipline, and certainty of institutional finance.</p>
                <p className="text-lg leading-relaxed font-light">
                  Our legacy is built on a foundation of high-trust relationships and sophisticated underwriting. 
                  Positioned alongside industry titans, we deliver a matte-black, elite experience that prioritizes 
                  strategic execution over volume.
                </p>
              </div>

              <div className="pt-4 flex flex-wrap gap-6">
                <Button asChild variant="outline" className="rounded-none border-border hover:bg-foreground hover:text-background hover:border-foreground transition-all duration-300 h-14 px-10 text-base uppercase tracking-wide">
                  <Link to="/ContactPage">
                    Request Capital <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
                
                <Button asChild variant="ghost" className="rounded-none text-muted-foreground hover:text-foreground hover:bg-transparent h-14 px-6 text-base uppercase tracking-wide group">
                  <Link to="/RealEstateCapitalPage">
                    Explore Solutions 
                    <span className="block h-[1px] w-0 bg-foreground transition-all duration-300 group-hover:w-full absolute bottom-3 left-6"></span>
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}